import router from "@/router";

export const changeUrl = (url) => {
    router.push(url)
    window.scrollTo(0, 0);
  }